import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes.js";
function filterProductNodes(currentNode) {
  var objToKeep = ['images', 'generated_tcvars', 'prices', 'quantity_lot', 'reference', 'reference_encoded', 'translations'];
  var obj = false;
  if (objToKeep.includes(currentNode[0])) {
    obj = true;
  }
  return obj;
}
function fetchProductList(_x, _x2) {
  return _fetchProductList.apply(this, arguments);
}
function _fetchProductList() {
  _fetchProductList = _asyncToGenerator(function* (context, payload) {
    var xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(context.getters['i18n/locale'].market, "/").concat(context.getters['i18n/locale'].language, "/layer-products/").concat(payload);
    var {
      data
    } = yield context.$axios.get(xhrUri);
    var cNode = {};
    var newData = Object.entries(data).reduce((prev, cur) => {
      var curVal = Object.entries(cur[1]).filter(filterProductNodes).reduce((obj, item) => {
        var newObj = obj;
        newObj[item[0]] = item[1];
        return newObj;
      }, {});
      cNode[cur[0]] = curVal;
      return cNode;
    }, {});
    return Object.keys(newData);
  });
  return _fetchProductList.apply(this, arguments);
}
export { fetchProductList as default };